import React, { Component } from 'react';
import { Input, Form, Modal, Button, message,Select } from 'antd';
import { Message } from 'semantic-ui-react'
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';

const TextArea = Input.TextArea;

class DelUserAccessModalDialog extends Component {

    refreshQuery() {
        const {
            userName,
            status
        } = this.props.userAccessQueryFields;
        this.props.loadUserAccessInfo({userName, status})
    }
    getPageNameByMode = (mode) => {
        if(mode === 'inactive') {
            return 'Inactive User Access Info';
        } 
        if(mode === 'REPLACE'){
            return 'REPLACE User ';
        }
        if(mode === 'del'){
            return 'DEL User Access Info';
        }
    }
    componentDidUpdate() {
        const {
            delUserAccessStatus,
        } = this.props;
        if(delUserAccessStatus === ACTION_STATUS.SUCCESS) {

            const mode = this.props.delUserAccessModal.mode;
            const info = this.getPageNameByMode(mode) + ' succeeded';
            message.success(info);
            this.props.initDelUserAccessActionStatus();
            this.props.resetDelUserAccessModal();
            this.refreshQuery();
        }
        if(delUserAccessStatus === ACTION_STATUS.ERROR) {
            this.props.initDelUserAccessActionStatus();
        }
    }


    onInputChange = ({name, value}) => {
        this.props.delUserAccessChangeInput({name, value});
    }


    submitDelUserAccess = () => {

        Modal.confirm({
            title: 'Are you sure del or inactive or replace this record?',
            onOk: () => {

                const {
                    mode,
                    idList,
                } = this.props.delUserAccessModal;
                const {
                    id,
                    comments,
                    employee,
                } = this.props.delUserAccessModal.fields;
                this.props.delUserAccess({id, mode, comments,employee,idList});
            },
            onCancel: () => {},
        });
    }


    render() {

        const {
            delUserAccessModal,
            delUserAccessStatus,
            userAccountOptions,
        } = this.props;
        const {
            isOpened,
            mode,
            idList,
            respErrMsg,
        } = delUserAccessModal;


        const isSubmitLoading = delUserAccessStatus === ACTION_STATUS.LOGINING;
        const modalTitle = this.getPageNameByMode(mode);
        const replaceFlag = mode ==='REPLACE'
        return (
            <div>
                <Modal
                    title={modalTitle}
                    centered
                    width={400}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetDelUserAccessModal()}
                    footer={[
                        <Button key="back" onClick={() => this.props.resetDelUserAccessModal()}>
                          Close
                        </Button>,
                        <Button key="save" type="primary" loading={isSubmitLoading} onClick={this.submitDelUserAccess}>
                          Submit
                        </Button>,
                      ]}
                >
                    {
                    replaceFlag && 
                        <Select
                                allowClear
                                showSearch
                                style={{ width: 350, marginLeft: 0 }}
                                onChange={(val) => {
                                    this.onInputChange({ name: 'employee', value: val })
                                }} 
                                placeholder="replace with user">
                            {userAccountOptions}
                        </Select>
                    }
                        <TextArea 
                       
                            style={{ width: 400 ,marginTop: 10}}
                            rows={3} 
                            placeholder="Remark"
                            onChange={(e) => {
                                this.onInputChange({ name: 'comments', value: e.target.value })
                            }}
                        />
                        {
                        !!respErrMsg &&  
                        <Message negative>
                            <Message.Header>Response Error Message</Message.Header>
                            <p>{ respErrMsg }</p>
                        </Message>
                        }
                </Modal>
                
            </div>
        );
    }

}

const DelUserAccessModalDialogForm = Form.create({ name: 'DelUserAccessModalDialog' })(DelUserAccessModalDialog);
export default DelUserAccessModalDialogForm;
